import React from "react";
import {Col} from "antd";
import {
    CompanyFilter,
    SubCompanyFilter,
    SearchText,
    CourierFilter
} from "../../../_defaultComponents/FilterComponents";

export const BackofficeConvertedToCashTabFilters = ({filters, setFilters}) => {
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CompanyFilter
                    value={filters.companyId}
                    onChange={value =>
                        setFilters({...filters, companyId: value, subcompanyId: undefined})
                    }
                    allowClear={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <h5>Alt Firma</h5>
                <SubCompanyFilter
                    value={filters.subcompanyId}
                    onChange={value => setFilters({...filters, subcompanyId: value})}
                    company={filters.companyId}
                    showSearch={true}
                    allowClear={true}
                    showAllOption={false}
                    hideTitle={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.vigoOrderNumber}
                    onChange={value =>
                        setFilters({...filters, vigoOrderNumber: value.toUpperCase()})
                    }
                    label="Sipariş No"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CourierFilter
                    value={filters.courierId}
                    onChange={value => setFilters({...filters, courierId: value})}
                    allowClear={true}
                />
            </Col>
        </React.Fragment>
    );
};
